export const ASPECT_RATIOS = {
  wide: 16 / 9,
  square: 1,
};

export const EXPORT_SIZES = {
  large: 3840,
  medium: 2560,
  small: 1920,
};

export const FOOTER_STYLES = {
  GRADIENT: 'gradient',
  DARK: 'dark',
  LIGHT: 'light',
  NONE: 'none',
};

export const EXPORT_FILE_TYPE = 'jpeg';

// Calculate Height from a given with and aspect ratio
export const getHeightFromWidth = (width, ratio) =>
  Math.floor(EXPORT_SIZES[width] / ratio);
